// src/components/extensions/Video.ts
import { Node } from "@tiptap/core";

const Video = Node.create({
  name: "video",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      src: { default: null },
      controls: { default: true },
      style: { default: "max-width:100%;border-radius:8px;" },
    };
  },

  parseHTML() {
    return [{ tag: "video" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["video", HTMLAttributes];
  },
});

export default Video;
